import Components from './../Component';

export default class Ads extends Components {

  constructor($) {
    super($);
  }

  init(index, element) {
    var random_index = Math.floor((Math.random() * this.$(element).children().length) + 0);
    this.$(element).find('.ad').eq(random_index).addClass('active');
  }
}